<template>
	<div class="indexPage">
		<div style="height: 75px;"></div>
		<extra></extra>
		<advertisement></advertisement>
		<div class="topArea">
			<div class="top-container">
				<div class="topMenu">
					<div class="top-logo-nav">
						<a href="" class="top-logo" title="叮咚智造泛工业互联网平台">
							<img src="../assets/logo/ddlogo-02.png" alt="">
						</a>
					</div>
					<div class="top-user">
						<div class="userInfoNav">
							<div class="index-nav-login" v-if="typeof (this.$store.state.username) == 'object'">
								<div class="avatar">
									<img src="../assets/icon/nologin.jpg" alt="">
								</div>
								<a class="uers-text" href="/login?redirect_uri=http://www.ddzzii.com/">登录/注册</a>
							</div>
							<div class="index-nav-logout" v-if="typeof (this.$store.state.username) == 'string'">
								<el-dropdown @command="handleCommand">
								  <span class="el-dropdown-link">
								    <div class="avatar">
								    	<img :src="$store.state.userIcon" alt="">
								    </div>
									<a  class="uers-text">{{ $store.state.username }}</a>
								  </span>
								  <el-dropdown-menu slot="dropdown">
								    <el-dropdown-item command="a">安全中心</el-dropdown-item>
								    <el-dropdown-item command="b">退出登录</el-dropdown-item>
								  </el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
					</div>
					<div class="top-menu-nav">
						<ul>
							<li class="active">
								<a class="cur" title="首页">首页</a>
							</li>
							<li>
								<a title="使用指南">使用指南</a>
							</li>
							<li>
								<a title="平台快讯">平台快讯</a>
							</li>
							<li>
								<a href="/feedback" title="意见反馈">意见反馈</a>
							</li>
							<li>
								<a title="联系我们">联系我们</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="header">
			<div class="header-box">
				<div class="header-carousel">
					<el-carousel height="400px" :interval="5000">
						<el-carousel-item>
							<div class="LBTbox"></div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="LBTbox"></div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="LBTbox"></div>
						</el-carousel-item>
						<el-carousel-item>
							<div class="LBTbox"></div>
						</el-carousel-item>
					 </el-carousel>
				</div>
			</div>
		</div>
		<div class="wrap-list">
			<div id="wrap">
				<ul>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('gr.ddzzii.com')"
					>
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/gr.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>共享工人</div>
							</div>
							<div class="platformNavBottom">
								<div>工人找工厂</div>
								<div>工厂找工人</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/gxcc.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>共享仓储</div>
							</div>
							<div class="platformNavBottom">
								<div>工业云仓库</div>
								<div>仓储在指尖</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/znzz.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>智能制造</div>
							</div>
							<div class="platformNavBottom">
								<div>智慧小工厂</div>
								<div>全网大数据</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/ddsc.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>叮咚商城</div>
							</div>
							<div class="platformNavBottom">
								<div>半成工业品</div>
								<div>大宗原材料</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/ddhy.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>叮咚货运</div>
							</div>
							<div class="platformNavBottom">
								<div>闲散拉货车</div>
								<div>为工厂守候</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('jbgs.ddzzii.com')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/jbgs.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>揭榜挂帅</div>
							</div>
							<div class="platformNavBottom">
								<div>英才大舞台</div>
								<div>合作创大业</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/gyljr.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>供应链金融</div>
							</div>
							<div class="platformNavBottom">
								<div>金融助企业</div>
								<div>企业利金融</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/zzybx.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>制造业保险</div>
							</div>
							<div class="platformNavBottom">
								<div>防患重泰山</div>
								<div>保险稳江山</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/bigdata.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>工业大数据</div>
							</div>
							<div class="platformNavBottom">
								<div>数据多跑路</div>
								<div>企业少跑腿</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/fktyc.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>访客天眼查</div>
							</div>
							<div class="platformNavBottom">
								<div>安全有迹循</div>
								<div>往来无疏漏</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/lldxt.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>蓝领优学堂</div>
							</div>
							<div class="platformNavBottom">
								<div>工人上网课</div>
								<div>制造上台阶</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
					<li
					@mouseenter="mouseEnt"
					@mouseleave="mouseLeave"
					@click="jump('')">
						<div class="text">
						</div>
						<div class="platformNav">
							<div class="platformNavTop">
								<img src="../assets/icon/fw.png" alt="" class="platformLogo">
							</div>
							<div>
								<div class="FGX"></div>
							</div>
							<div class="platformNavMedium">
								<div>服务深一度</div>
							</div>
							<div class="platformNavBottom">
								<div>更多好服务</div>
								<div>叮咚持续来</div>
							</div>
							<div class="platformNavButtom">
								<el-button type="text" class="platformButtom">点击直达</el-button>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<footer-layout></footer-layout>
	</div>
</template>

<script>
  import FooterLayout from '@/components/layout/FooterLayout'
  import Advertisement from '@/components/fixed/Advertisement'
  import Extra from '@/components/fixed/Extra'
  export default {
    name: 'Index',
	components: {
	  FooterLayout,
	  Extra,
	  Advertisement
	},
    data(){
      return {
		active: ''
      }
    },
    methods:{
	  handleCommand (command) {
	    if (command === 'a') {
	      window.location.href = 'http://www.ddzzii.com/secure'
	    } else if (command === 'b') {
	      window.localStorage.clear('token')
	      window.localStorage.clear('refresh_token')
	      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 GMT'
	      document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT'
	      window.location.reload()
	    }
	  },
      mouseEnt(ev) {
		  ev.target.firstChild.style.background = '#9b0505'
	  },
	  mouseLeave(ev) {
		  ev.target.firstChild.style.background = '#000'
	  },
	  jump (url) {
		  if (url === '') {
			  this.$message.error('正在开发中');
		  }
		  // window.location.href = 'http://' + url
		  url = 'http://' + url
		  window.open(url)
	  },
	  _isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			return flag;
		}
    },
    created(){
    },
	mounted() {
		if(this._isMobile()){
			this.$router.replace('/m/index')
		}
		else{
			console.log('pc')
		}
	}
  }
</script>

<style>
.index-top {
	width: 1105px;
	margin: 0 auto;
	overflow: hidden;
}
.indexPage .header{
	text-align: center;
	/* width: 1000px; */
	width: 100%;
}
.header-box {
	margin: 0 auto;
}
.header-carousel{
}
.LBT{
	height: 400px;
	width: 2000px;
}
.LBTbox {
	background: url(../assets/lbt4.jpg) center no-repeat;
	width: 100%;
	height: 400px;
}
</style>

<style scoped>
.bg{
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
.bg-box-1{
	/* background: url(../assets/bg.jpg); */
}
.bg-box-2,.bg-box-3,.bg-box-4,.bg-box-5,.bg-box-6,.bg-box-7,.bg-box-8,.bg-box-9,.bg-box-10,.bg-box-11{
	display: none;
}
.wrap-list{
	width: 1105px;
	margin: 0 auto;
}
#wrap {
	color: #fff;
    /* position: absolute; */
    overflow: hidden;
	margin-right: -10px;
	margin-top: 20px;
}
#wrap > ul > li {
	float: left;
	width: 180px;
	height: 250px;
	cursor: pointer;
	transition: all 2s;
	margin: 0 5px 5px 0;
	border-radius: 4px;
}
#wrap > ul > li .text {
	width: 180px;
	height: 250px;
	background:#000;
	opacity: 0.5;
	position:absolute;
	border-radius: 4px;
}
#wrap > ul > li .platformNav {
	text-align: center;
	position:relative;
	height: 250px;
}
.LastplatformNav {
	text-align: center;
	position:relative;
	margin: 10px auto;
	width: 1020px;
	height: 100px;
}
.platformNavL, .LastplatformFGX, .platformNavR{
	height: 100px;
	float: left;
}
.platformNavL .platformLogo{
	margin: 14px 0 14px 266px;
	width: 72px;
	transition: all 0.5s;
}
.LastplatformNav:hover .platformLogo{
	margin: 10px 0 10px 258px;
	width: 80px;
}
.LastplatformNav:hover .JBGSConcern{
	margin-left: 10px;
}
.JBGSTitle {
	/* width: 500px; */
	margin: 24px 0 0px 0px;
	font-size: 20px;
}
.JBGSTitle span{
	opacity: 0;
	transition: all 0.5s;
}
.LastplatformNav:hover span{
	opacity: 1;
}
.JBGSConcern {
	margin-top: 10px;
	margin-left: 50px;
	font-size: 10px;
	transition: all 0.5s;
}
.JBGSConcern a {
	margin: 0px 10px;
}
.LastplatformFGX {
	height: 60px;
	margin: 20px 63px;
	border-radius: 20%;
	border-right: 1px solid #fff;
}
#DDZZLogo {
	/* width: 600px; */
	height: 80px;
	width: 357px;
	float: left;
	/* margin: 0px auto 0; */
}
#DDZZLogo a{
	margin: 10px 0;
	background-image: url(../assets/ddlogo-021.png);
	width: 357px;
	height: 60px;
	float: left;
}
.userInfoNav {
	float: right;
	height: 75px;
	line-height: 75px;
}
.userInfoNav a{
	display: inline-block;
	cursor: pointer;
	font-size: 15px;
	color: #000000;
}
.userInfoNav a:hover{
	text-decoration: underline;
}
.userInfoNav .avatar{
	position: relative;
	width: 32px;
	height: 32px;
	display: inline-block;
	margin-left: 10px;
	cursor: pointer;
}
.userInfoNav .avatar img{
	width: 28px;
	height: 28px;
	border-radius: 15px;
}

.platformNavTop {
}
.platformNavMedium{
	 font-size: 16px;
	 margin: 20px 0 20px 0;
	 transition: all 0.5s;
}
.platformNav:hover .platformNavMedium{
	 margin: 10px 0 20px 0;
	 transition: all 0.5s;
}
.platformNavBottom{
	 font-size: 10px;
}
.platformNavButtom{
	opacity: 0;
	transition: all 0.5s;
}
.platformNav:hover .platformNavButtom{
	opacity: 1;
}

.platformButtom{
	color: #fff;
	margin-top: 20px;
	background: 0 0;
	border: 1px solid;
	padding: 8px;
	border-radius: 0;
}
#wrap > ul > li .platformNav .platformLogo {
	margin-top: 48px;
	height: 40px;
	transition: all 0.5s;
}
#wrap > ul > li .platformNav:hover .platformLogo {
	margin-top: 20px;
	height: 48px;
}
.platformMore {
	font-size: 16px;
	line-height: 250px;
}
.FGX {
	width: 20px;
	margin: 20px auto 0;
	border-radius: 20%;
	border-bottom: 1px solid #fff;
	transition: all 0.5s;
}
.platformNav:hover .FGX{
	opacity: 0;
}
#wrap > ul > li:nth-child(1){
	background: url(../assets/icon/gr.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(2){
	background: url(../assets/icon/gxcc.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(3){
	background: url(../assets/icon/znzz.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(4){
	background: url(../assets/icon/ddsc.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(5){
	background: url(../assets/icon/ddhy.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(6){
	background: url(../assets/icon/jbgs.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(7){
	background: url(../assets/icon/gyljr.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(8){
	background: url(../assets/icon/zzybx.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(9){
	background: url(../assets/icon/bigdata.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(10){
	background: url(../assets/icon/fktyc.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(11){
	background: url(../assets/icon/lldxt.jpg) no-repeat center/cover;
}
#wrap > ul > li:nth-child(12){
	background: url(../assets/icon/fwsyd.png) no-repeat center/cover;
}
</style>

<style>
	.indexPage .topArea {
		position: fixed;
		right: 0;
		left: 0;
		top: 0;
		z-index: 1500;
		/* width: 100%; */
		height: 75px;
		line-height: 75px;
		border-bottom: 1px solid;
		border-color: #EEEEEE;
		transition: all .6s ease;
		background-color: #fff;
	}
	.indexPage .topAreaMove{
		background: #000000;
	}
	.top-container{
	    width: 1105px;
	    margin: 0 auto;
	  }
	.topArea .topMenu {
		overflow: hidden;
	}
	.topArea .top-logo-nav {
		position: absolute;
		top: 0;
		height: 100%;
		font-size: 0;
		max-width: 45%;
		z-index: 3;
	}
	.top-logo img {
	    /* height: 100%; */
		height: 50px;
	    /* padding: 10px 0; */
	    max-width: 100%;
	}
	img {
	    vertical-align: middle;
	}
	.topArea .top-menu-nav {
		width: 474px;
		float: right;
		overflow: hidden;
		position: relative;
		z-index: 2;
	}
	.topArea .top-menu-nav ul{
		display: block;
		margin: 0;
		padding: 0;
		list-style: none;
		width: 3999px;
	}
	.topArea .top-menu-nav ul li{
		float: left;
		margin: 0;
		padding: 0;
		list-style: none;
		position: relative;
		white-space: nowrap;
		cursor: pointer;
	}
	.topArea .top-menu-nav ul li.active a::after,
	.topArea .top-menu-nav ul li:hover a::after {
	  width: 100%;
	}
	.topArea .top-menu-nav ul li.active a.cur {
	  color: #1492ff;
	  background: #F3F4F8;
	}
	.topArea .top-menu-nav ul li a::after {
		content: '';
		height: 3px;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 0;
		background: #1492ff;
		transition: all .6s ease;
	}
	.topAreaMove .top-menu-nav ul li a::after {
		background-color: #ff6600;
	}
	.topArea .top-menu-nav ul li a{
		display: block;
		position: relative;
		color: #000000;
	}
	.topArea .top-menu-nav ul li a{
		display: block;
		padding: 0 15px;
		font-weight: normal;
		position: relative;
		z-index: 2;
		color: #000000;
		transition: color .3s;
		-moz-transition: color .3s;
		-ms-transition: color .3s;
		-o-transition: color .3s;
		-webkit-transition: color .3s;
		font-size: 18px;
		/* font-weight: 800; */
	}
	.top-user{
		cursor: pointer;
		z-index: 1501;
		transition: all ease 0.6s;
		float: right;
	}
	.top-user a{
		color: #000000;
	}
	.index-nav-login a.uers-text{
		font-size: 18px;
		font-weight: normal;
		/* font-weight: 800; */
	}
</style>

<!-- <style>
	#IndexMain {
		overflow: hidden;
		width: 1401px;
		margin: 0 auto;
	}
	#IndexMain .adver-left,
	#IndexMain .adver-right{
		margin-top: 20px;
		float: left;
		width: 138px;
		height: 505px;
	}
	#IndexMain .adver-left {
		margin-right: 10px;
	}
	#IndexMain .adver-right {
		margin-left: 10px;
	}
	#IndexMain .adver-left img{
		width: 138px;
		height: 505px;
	}
	#IndexMain .adver-right img{
		width: 138px;
		height: 505px;
	}
	#IndexMain .wrap-list {
		float: left;
	}
</style> -->
